/**
 * pages/PendingPage.jsx
 *
 * Shown when the user is logged in but their role is 'pending' —
 * i.e. they've signed in with Google but haven't been approved yet.
 */

import React from 'react';
import { useUser } from '../context/UserContext';

export default function PendingPage() {
  const { user, logout } = useUser();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--paper)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'var(--font-ui)',
      color: 'var(--ink)',
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '0.5px solid var(--hair)',
        borderRadius: 16,
        padding: '48px 52px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 420,
        width: '90vw',
        boxShadow: '0 24px 64px rgba(0,0,0,0.35)',
        textAlign: 'center',
      }}>

        {/* User avatar */}
        {user?.picture ? (
          <img
            src={user.picture}
            alt={user.name}
            style={{
              width: 64, height: 64, borderRadius: '50%',
              border: '2px solid var(--hair)',
              marginBottom: 16,
            }}
          />
        ) : (
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'var(--surface-2)',
            border: '2px solid var(--hair)',
            marginBottom: 16,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, color: 'var(--ink-3)',
          }}>
            {user?.name?.[0]?.toUpperCase() || '?'}
          </div>
        )}

        {/* Name */}
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)', marginBottom: 4 }}>
          {user?.name || 'Welcome'}
        </div>
        <div style={{ fontSize: 12, color: 'var(--ink-3)', marginBottom: 32 }}>
          {user?.email}
        </div>

        {/* Pending clock icon */}
        <div style={{
          width: 52, height: 52, borderRadius: '50%',
          background: 'rgba(251,191,36,0.1)',
          border: '0.5px solid rgba(251,191,36,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24, marginBottom: 20,
        }}>
          ⏳
        </div>

        <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 10 }}>
          Access Request Pending
        </div>

        <div style={{
          fontSize: 13, color: 'var(--ink-2)',
          lineHeight: 1.7, marginBottom: 32,
        }}>
          Your Google sign-in was successful. An administrator will review
          your access request and assign you a role shortly.
          <br/><br/>
          You'll be able to log in immediately once approved —
          no further action required on your end.
        </div>

        {/* Logout button */}
        <button
          onClick={logout}
          style={{
            background: 'transparent',
            border: '0.5px solid var(--hair-strong)',
            borderRadius: 8,
            padding: '9px 24px',
            fontSize: 12,
            color: 'var(--ink-3)',
            cursor: 'pointer',
            fontFamily: 'var(--font-ui)',
            letterSpacing: '0.03em',
          }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--ink)'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--ink-3)'}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
